/* Copyright 2013 - 2024 Waiterio LLC */
export default {
  authrice: {
    staging: 'authrice-staging.com',
    production: 'authrice.com',
  },
  waiterio: {
    staging: 'waiterio-staging.com',
    production: 'waiterio.com',
  },
  tiramisu: {
    staging: 'tiramisu-staging.cloud',
    production: 'tiramisu.cloud',
  },
  imagelato: {
    staging: 'imagelato-staging.com',
    production: 'imagelato.com',
  },
  metricsmage: {
    staging: 'metricsmage-staging.com',
    production: 'metricsmage.com',
  },
  multilocale: {
    staging: 'multilocale-staging.com',
    production: 'multilocale.com',
  },
  polyblog: {
    staging: 'polyblog-staging.io',
    production: 'polyblog.io',
  },
  supovia: {
    staging: 'supovia-staging.com',
    production: 'supovia.com',
  },
  sharepa: {
    staging: 'sharepa-staging.social',
    production: 'sharepa.social',
  },
  croncool: {
    staging: 'croncool-staging.com',
    production: 'cron.cool',
  },
  churncatcher: {
    staging: 'churncatcher-staging.com',
    production: 'churncatcher.com',
  },
  dododentist: {
    staging: 'dododentist-staging.com',
    production: 'dododentist.com',
  },
  appskyline: {
    staging: 'appskyline-staging.com',
    production: 'appskyline.com',
  },
  veterical: {
    staging: 'veterical-staging.com',
    production: 'veterical.com',
  },
  wapiworld: {
    staging: 'wapiworld-staging.com',
    production: 'wapiworld.com',
  },
  prosperanova: {
    staging: 'prosperanova-staging.com',
    production: 'prosperanova.com',
  },
  dbmuse: {
    staging: 'dbmuse-staging.com',
    production: 'dbmuse.com',
  },
  gammainvestments: {
    staging: 'gammainvestments-staging.cc',
    production: 'gammainvestments.cc',
  },
  invoicevista: {
    staging: '',
    production: 'invoicevista.com',
  },
  hairdora: {
    staging: 'hairdora-staging.com',
    production: 'hairdora.com',
  },
  doctofam: {
    staging: 'doctofam-staging.com',
    production: 'doctofam.com',
  },
  hotelumo: {
    staging: 'hotelumo-staging.com',
    production: 'hotelumo.com',
  },
  barberbrio: {
    staging: 'barberbrio-staging.com',
    production: 'barberbrio.com',
  },
  bonitabook: {
    staging: 'bonitabook-staging.com',
    production: 'bonitabook.com',
  },
  gymflexa: {
    staging: 'gymflexa-staging.com',
    production: 'gymflexa.com',
  },
  opticalora: {
    staging: 'opticalora-staging.com',
    production: 'opticalora.com',
  },
  mechaniczen: {
    staging: 'mechaniczen-staging.com',
    production: 'mechaniczen.com',
  },
  pharmaphoria: {
    staging: 'pharmaphoria-staging.com',
    production: 'pharmaphoria.com',
  },
  tutorializer: {
    staging: 'tutorializer-staging.com',
    production: 'tutorializer.com',
  },
  pushello: {
    staging: 'pushello-staging.com',
    production: 'pushello.com',
  },
  socketino: {
    staging: 'socketino-staging.com',
    production: 'socketino.com',
  },
}
